import { render, staticRenderFns } from "./AssocEvidence.vue?vue&type=template&id=0fe476fc&scoped=true&"
import script from "./AssocEvidence.vue?vue&type=script&lang=ts&"
export * from "./AssocEvidence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe476fc",
  null
  
)

export default component.exports